// Surf scoring — main-thread scoreboard config
// Tracks best completion times and current run progress for all players.

import { SimEventType } from "../../engine/events.js";
import { formatTicks, type ScoreboardConfig } from "../scoring.js";

const MAX_PLAYERS = 64;

export function surfScoreboard(): ScoreboardConfig {
  const bestTicks = new Int32Array(MAX_PLAYERS);
  const currentTicks = new Int32Array(MAX_PLAYERS);

  return {
    columns: [
      {
        key: "bestTime",
        label: "Best Time",
        format: v => v === 0 ? "\u2014" : formatTicks(v),
        sortDirection: "asc",
      },
      {
        key: "currentTime",
        label: "Current",
        format: v => v === 0 ? "\u2014" : formatTicks(v),
        sortDirection: "asc",
      },
    ],

    processEvent(pid, type, d0) {
      if (pid < 0 || pid >= MAX_PLAYERS) return;
      if (type === SimEventType.TIMER_UPDATE) {
        currentTicks[pid] = d0;
      } else if (type === SimEventType.TIMER_STOP) {
        if (bestTicks[pid] === 0 || d0 < bestTicks[pid]) bestTicks[pid] = d0;
        currentTicks[pid] = 0;
      }
    },

    sortValue: pid => bestTicks[pid],

    columnValue(pid, key) {
      if (key === "bestTime") return bestTicks[pid];
      if (key === "currentTime") return currentTicks[pid];
      return 0;
    },

    hasScore: pid => bestTicks[pid] > 0,
  };
}
